(() => {
  if (window.__cartCountHooked__) return;
  window.__cartCountHooked__ = true;

  const sel = ".header__cart-count";
  const re =
  /\/cart\/(add|change|update|clear)(?:\.js)?(?:\?|$)/i;

let badgeLocked = false;
let stableBadgeCount = null;
let restoringBadge = false;

const set = (n, final = false) => {
  if (typeof n !== "number") return;
  if (badgeLocked && !final) return;

  document.querySelectorAll(sel).forEach((el) => {
    el.textContent = String(n);
    el.style.visibility = "visible";
    el.classList.remove(
      "hidden",
      "opacity-0",
      "invisible"
    );
  });

  if (final) {
    stableBadgeCount = n;
    badgeLocked = false;
  }
};

const lockBadge = () => {
  if (badgeLocked) return;

  const currentCount = Number(
    document.querySelector(sel)?.textContent
  );

  if (Number.isFinite(currentCount)) {
    stableBadgeCount = currentCount;
  }

  badgeLocked = true;
};

const badgeObserver = new MutationObserver(() => {
  if (
    !badgeLocked ||
    restoringBadge ||
    stableBadgeCount === null
  ) {
    return;
  }

  restoringBadge = true;

  document.querySelectorAll(sel).forEach((el) => {
    if (
      el.textContent !== String(stableBadgeCount)
    ) {
      el.textContent = String(stableBadgeCount);
    }
  });

  queueMicrotask(() => {
    restoringBadge = false;
  });
});

badgeObserver.observe(document.documentElement, {
  childList: true,
  characterData: true,
  subtree: true
});

  
  // ---- Supercart refresh helper (debounce + single-flight) ----
  let supercartTimer = null;
  let supercartInFlight = false;

  const triggerSupercartUpdate = () => {
    if (supercartInFlight) return;

    clearTimeout(supercartTimer);
    supercartTimer = setTimeout(() => {
      supercartInFlight = true;

      document.documentElement.dispatchEvent(
        new Event("supercart:update")
      );

      // release lock after Supercart has had time to react
      setTimeout(() => {
        supercartInFlight = false;
      }, 400);
    }, 50);
  };

  const fetchOrig = window.fetch;
  window.fetch = async function (...args) {
    const input = args[0];
    const url = typeof input === "string" ? input : input?.url || "";
    const isCartMutation = re.test(url);

if (isCartMutation) {
  lockBadge();
}

const res = await fetchOrig.apply(this, args);

if (!isCartMutation) return res;

    try {
      const json = await res.clone().json();

     if (typeof json?.item_count === "number") {
  triggerSupercartUpdate();
}


clearTimeout(window.__cartBadgeSyncTimer__);

window.__cartBadgeSyncTimer__ = setTimeout(async () => {
  try {
    const root = window.Shopify?.routes?.root || "/";

    const cartResponse = await fetchOrig(
      `${root}cart.js`,
      {
        credentials: "same-origin",
        headers: {
          Accept: "application/json"
        },
        cache: "no-store"
      }
    );

    if (!cartResponse.ok) return;

    const cart = await cartResponse.json();

    set(cart.item_count, true);
triggerSupercartUpdate();
  } catch (_) {}
}, 1000);
    } catch (_) {}

    return res;
  };
})();
